import * as Yup from 'yup';
import { Validator } from '../../../shared/constants/validator';
import { Utils } from '../../../shared/constants/utilities.constants';

type TranslateFunction = (key: string) => string;

export const createBuildingSiteValidationSchema = (t: TranslateFunction) =>
    Yup.object({
        name: Yup.string()
            .required(t('buildingSiteForm.REQUIRED_NAME'))
            .min(Validator.minLengthName, t('buildingSiteForm.INVALID_NAME'))
            .max(Validator.maxLengthName, t('buildingSiteForm.INVALID_NAME')),

        street: Yup.string()
            .required(t('buildingSiteForm.REQUIRED_STREET'))
            .min(Validator.minLengthName, t('buildingSiteForm.INVALID_STREET'))
            .max(Validator.maxLengthName, t('buildingSiteForm.INVALID_STREET')),

        countryId: Yup.string()
            .test(
                'required-guid',
                t('buildingSiteForm.REQUIRED_COUNTRY'),
                (value) => !!value && value !== Utils.defaultUuid
            )
            .required(t('buildingSiteForm.REQUIRED_COUNTRY')),

        postalCode: Yup.string()
            .required(t('buildingSiteForm.REQUIRED_ZIP'))
            .max(Validator.maxLengthName, t('buildingSiteForm.INVALID_ZIP')),

        city: Yup.string()
            .required(t('buildingSiteForm.REQUIRED_CITY'))
            .min(Validator.minLengthName, t('buildingSiteForm.INVALID_CITY'))
            .max(Validator.maxLengthName, t('buildingSiteForm.INVALID_CITY')),

        buildingNumber: Yup.string().max(Validator.maxLengthName, t('buildingSiteForm.INVALID_BUILDING_NUMBER')),

        comment: Yup.string().max(Validator.textAreaLengthLimit, t('buildingSiteForm.INVALID_COMMENT')),

        contact: Yup.string()
            .min(Validator.minLengthName, t('buildingSiteForm.INVALID_CONTACT'))
            .max(Validator.maxLengthName, t('buildingSiteForm.INVALID_CONTACT')),

        reference: Yup.string()
            .min(Validator.minLengthName, t('buildingSiteForm.INVALID_REFERENCE'))
            .max(Validator.maxLengthName, t('buildingSiteForm.INVALID_REFERENCE')),
    });
